import { zaPrefillAttributeMissing } from "../../../utils/monitoring-utils/monitoring-utils"

export const normalize = (s: string) => s?.toLowerCase?.() ?? ''

export const isEmpty = (value: any, attribute: string, source: string): boolean => {
    const res = value === undefined || value === null || (typeof value === 'string' && value.trim() === '')
    if (res) zaPrefillAttributeMissing({ source, attribute, value, origin: 'isNullOrEmpty' })
    return res
}
